import { createSelector } from '@ngrx/store';

import { selectFehHomebatteryState } from '../feh-homebattery.state';

export const selectHomeBatteryConsumptionState = createSelector(
  selectFehHomebatteryState,
  (state) => state['homebattery-wizard'].consumption
);

export const selectHomeBatteryConsumptionEstimateValueState = createSelector(
  selectFehHomebatteryState,
  (state) => state['homebattery-wizard'].formData?.consumptionPerYear
);
